<div class="OcrCvTblContainPage-content">
    <div class="upload-col">
      <show-need-top-up *ngIf="showNeedTopUp"></show-need-top-up>
      <div *ngIf="!showNeedTopUp" draggable="true" ngClass="{{dragAreaClass}}" (click)="file.click()">
        <div>
          <div class=" text-center">
            <div *ngIf="!draggedFiles" class="dragareaContain">
              {{"Drag an Image/PDF file containing a document here\." | i18n}}
  
            </div>
            <input type="file" #file [multiple]="false" (change)="onFileChange($event)" style="display:none" />
            <div class="dragged-files-wrapper" *ngIf="draggedFiles">
              <div class="file" *ngFor="let file of draggedFiles">
                {{file.name}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="error" *ngIf="error">
        {{"Only one file at time allow | i18n"}}
      </div>
      <ocrCvTblTable #ocrCvTblTable></ocrCvTblTable>
  
  
    </div>
    <div class="canvas-col canvasCompContain ocrCvTblCanvasColumn" #canvasCompContain
      [style.maxHeight.px]="windowHeight-100">
  
      <app-canvas-comp #canvasComp [imageURL]="imageURL" [fileName]="fileName">
        <!-- *ngIf="imageURL && imageURL !== ''" -->
      </app-canvas-comp>
    </div>
  </div>
  <div id="loader" *ngIf="loadingFlag"></div>